module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.b27e3ea0.svg";